'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.treatValue = undefined;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var descriptorText = function descriptorText(value) {

    if (value !== null && typeof value !== 'string') {
        value = String(value);
    }

    return value;
};

var descriptorBoolean = function descriptorBoolean(value) {
    if (typeof value !== 'boolean') {
        return value === 'true';
    }

    return value;
};

var descriptorDateTime = function descriptorDateTime(value) {
    return (0, _moment2.default)(value).toDate();
};

var descriptorDateOnly = function descriptorDateOnly(value) {
    return (0, _moment2.default)(value).toDate();
};

var descriptorNumber = function descriptorNumber(value) {
    return Number(value);
};

var descriptorDataset = function descriptorDataset(value, _ref) {
    var dataType = _ref.dataType;

    var attribute = descriptorDataTypes[dataType.toUpperCase()];

    return attribute(value);
};

var descriptorDataTypes = {
    SMALL_TEXT: descriptorText,
    LARGE_TEXT: descriptorText,
    BOOLEAN: descriptorBoolean,
    INTEGER: descriptorNumber,
    REAL: descriptorNumber,
    DATETIME: descriptorDateTime,
    DATEONLY: descriptorDateOnly,
    DATASET: descriptorDataset
};

var treatValue = function treatValue(_ref2) {
    var value = _ref2.value,
        dataType = _ref2.dataType,
        dataset = _ref2.dataset;

    if (!dataType) {
        return value;
    }

    if (value instanceof Array) {
        return value.map(function (v) {
            var treat = descriptorDataTypes[dataType.toUpperCase()];
            return treat(v, dataset);
        });
    }

    var treat = descriptorDataTypes[dataType.toUpperCase()];
    return treat(value, dataset);
};

exports.treatValue = treatValue;